import axios from 'axios'

const api = axios.create({
  withCredentials: true
})

api.defaults.withCredentials = true

export default api

export function setBaseUrl(baseUrl: string) {
  api.defaults.baseURL = baseUrl
}

export function setAcceptLanguage(language: string) {
  api.defaults.headers.common['Accept-Language'] = language
}

export function setCookies(cookie?: string) {
  if (process.server && cookie) {
    api.defaults.headers.common.cookie = cookie
  }
}

export function setXsrfToken(token: string) {
  if (token) {
    api.defaults.headers.common['X-XSRF-TOKEN'] = token
  }
}
